export { FormPhone } from './FormPhone';
export type { FormPhoneProps } from './FormPhone.types';
